import React, { useState } from "react";
import { Button, Row, Col, Input, Modal, ModalHeader, ModalBody } from "reactstrap";
import { CATALOGO_PERMISOS } from "./catalogoPermisos";

// Modal de permisos por secciones. Lo usan ListadoUsuarios y ListadoUsuariosAdmin.
function ModalPermisos({ isOpen, toggle, nombre, apellido, permisos, setPermisos, onGuardar }) {
  const [busca, setBusca] = useState("");
  const [soloValidaciones, setSoloValidaciones] = useState(false);

  const texto = busca.trim().toLowerCase();

  function pasaFiltro(item, grupo) {
    if (soloValidaciones && !item.v) return false;
    if (!texto) return true;
    return (
      item.l.toLowerCase().includes(texto) ||
      item.k.toLowerCase().includes(texto) ||
      grupo.grupo.toLowerCase().includes(texto)
    );
  }

  function cambia(llave, valor) {
    setPermisos((anteriores) => ({ ...anteriores, [llave]: valor }));
  }

  function marcaGrupo(grupo, valor) {
    setPermisos((anteriores) => {
      const nuevos = { ...anteriores };
      grupo.items.forEach((i) => {
        nuevos[i.k] = valor;
      });
      return nuevos;
    });
  }

  function marcaTodo(valor) {
    setPermisos((anteriores) => {
      const nuevos = { ...anteriores };
      CATALOGO_PERMISOS.forEach((g) =>
        g.items.forEach((i) => {
          nuevos[i.k] = valor;
        })
      );
      return nuevos;
    });
  }

  const activos = CATALOGO_PERMISOS.reduce(
    (total, g) => total + g.items.filter((i) => permisos[i.k]).length,
    0
  );
  const totalPermisos = CATALOGO_PERMISOS.reduce((t, g) => t + g.items.length, 0);

  return (
    <Modal size="xxl" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        <h4 style={{ margin: 0 }}>
          Permisos de {nombre} {apellido}{" "}
          <span style={{ fontSize: 13, fontWeight: 400, color: "#64748b" }}>
            ({activos} de {totalPermisos} activos)
          </span>
        </h4>
      </ModalHeader>
      <ModalBody>
        <Row className="align-items-center" style={{ marginBottom: 14 }}>
          <Col md={4}>
            <Input
              type="text"
              placeholder="Buscar permiso..."
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
            />
          </Col>
          <Col md={3}>
            <label style={{ margin: 0, fontSize: 13, cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={soloValidaciones}
                onChange={(e) => setSoloValidaciones(e.currentTarget.checked)}
                style={{ marginRight: 6 }}
              />
              Solo validaciones
            </label>
          </Col>
          <Col md={5} className="text-right">
            <Button size="sm" color="secondary" onClick={() => marcaTodo(true)}>
              Marcar todo
            </Button>{" "}
            <Button size="sm" color="secondary" onClick={() => marcaTodo(false)}>
              Quitar todo
            </Button>{" "}
            <Button color="success" onClick={onGuardar}>
              Guardar
            </Button>
          </Col>
        </Row>

        <div style={{ fontSize: 12, color: "#64748b", marginBottom: 10 }}>
          <span style={etiquetaValida}>VALIDA</span> = boton que valida, autoriza,
          ejecuta o cancela un movimiento.
        </div>

        <Row>
          {CATALOGO_PERMISOS.map((g) => {
            const items = g.items.filter((i) => pasaFiltro(i, g));
            if (!items.length) return null;
            const marcados = g.items.filter((i) => permisos[i.k]).length;
            return (
              <Col md={3} key={g.grupo} style={{ marginBottom: 16 }}>
                <div style={tarjeta}>
                  <div style={encabezado}>
                    <h5 style={tituloGrupo}>
                      {g.grupo}{" "}
                      <span style={{ fontWeight: 400, color: "#94a3b8", fontSize: 11 }}>
                        {marcados}/{g.items.length}
                      </span>
                    </h5>
                    <span style={{ whiteSpace: "nowrap" }}>
                      <Button
                        color="link"
                        style={botonMini}
                        onClick={() => marcaGrupo(g, true)}
                      >
                        Todo
                      </Button>
                      <Button
                        color="link"
                        style={botonMini}
                        onClick={() => marcaGrupo(g, false)}
                      >
                        Nada
                      </Button>
                    </span>
                  </div>
                  {items.map((i) => (
                    <label key={i.k} style={renglon}>
                      <input
                        type="checkbox"
                        checked={!!permisos[i.k]}
                        onChange={(e) => cambia(i.k, e.currentTarget.checked)}
                        style={{ marginRight: 7, marginTop: 3 }}
                      />
                      <span style={{ fontSize: 12.5, lineHeight: 1.25 }}>
                        {i.l}
                        {i.v ? <span style={etiquetaValida}>VALIDA</span> : null}
                      </span>
                    </label>
                  ))}
                </div>
              </Col>
            );
          })}
        </Row>

        <Row>
          <Col md={12} className="text-right">
            <Button color="success" onClick={onGuardar}>
              Guardar
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
}

const tarjeta = {
  border: "1px solid #e2e8f0",
  borderRadius: 8,
  padding: "10px 12px 12px 12px",
  height: "100%",
  backgroundColor: "#fff",
};

const encabezado = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: "1px solid #f1f5f9",
  paddingBottom: 6,
  marginBottom: 8,
};

const tituloGrupo = {
  margin: 0,
  fontSize: 13,
  fontWeight: 700,
  letterSpacing: 0.4,
  color: "#334155",
};

const botonMini = {
  padding: "0 4px",
  fontSize: 11,
  textDecoration: "none",
};

const renglon = {
  display: "flex",
  alignItems: "flex-start",
  marginBottom: 5,
  cursor: "pointer",
  fontWeight: 400,
};

const etiquetaValida = {
  marginLeft: 6,
  fontSize: 9,
  fontWeight: 700,
  color: "#92400e",
  backgroundColor: "#fef3c7",
  borderRadius: 4,
  padding: "1px 5px",
  verticalAlign: "middle",
};

export default ModalPermisos;
